var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack210({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,3.9a2.33,2.33,0,0,1,2,.89,5.67,5.67,0,0,1,.84,3.5,5.71,5.71,0,0,1-.85,3.5A2.32,2.32,0,0,1,8,12.67a2.46,2.46,0,0,1-2-1,5.69,5.69,0,0,1-.76-3.43A5.68,5.68,0,0,1,6,4.78,2.34,2.34,0,0,1,8,3.9ZM8,5.26a.89.89,0,0,0-.54.19,1.39,1.39,0,0,0-.36.69,9.56,9.56,0,0,0-.17,2.15A9.42,9.42,0,0,0,7,10.36a1.44,1.44,0,0,0,.39.76A.83.83,0,0,0,8,11.3a.8.8,0,0,0,.53-.19,1.18,1.18,0,0,0,.36-.68A9,9,0,0,0,9,8.29a9.52,9.52,0,0,0-.15-2.08,1.52,1.52,0,0,0-.38-.76A.86.86,0,0,0,8,5.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack210);
export default __webpack_public_path__ + "static/media/Symbolpack_2_10.65f899f8783b54cf9611dc7787db44c9.svg";
export { ForwardRef as ReactComponent };